.portal {
  z-index: 19 !important;
}